import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useBrand } from '../context/BrandContext'
import { useNavigate } from 'react-router-dom'
import { colors, s, ui } from '../styles/theme'

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000'

const style = {
  card: { ...s.card, padding: '24px' },
  input: s.input,
  label: s.labelNormal,
}

function Users() {
  const { account } = useBrand()
  const navigate = useNavigate()
  const [users, setUsers] = useState([])
  const [brands, setBrands] = useState([])
  const [loading, setLoading] = useState(true)
  const [showAdd, setShowAdd] = useState(false)
  const [editing, setEditing] = useState(null)
  const [saved, setSaved] = useState(false)
  const [resetGonderilen, setResetGonderilen] = useState(null)
  const [resetBekleyen, setResetBekleyen] = useState(null)
  const [form, setForm] = useState({ email: '', password: '', role: 'brand_admin', brand_id: '' })

  const token = localStorage.getItem('adminToken')
  const headers = { Authorization: token }

  useEffect(() => {
    if (account?.role !== 'super_admin') {
      navigate('/')
      return
    }
    fetchUsers()
    fetchBrands()
  }, []) // eslint-disable-line

  function fetchUsers() {
    setLoading(true)
    axios.get(`${API}/admin/users`, { headers })
      .then(res => { setUsers(res.data); setLoading(false) })
      .catch(() => setLoading(false))
  }

  function fetchBrands() {
    axios.get(`${API}/admin/brands`, { headers })
      .then(res => setBrands(res.data))
  }

  function showSaved() {
    setSaved(true)
    setTimeout(() => setSaved(false), 2500)
  }

  async function handleAdd() {
    if (!form.email || !form.password) return alert('Email ve şifre zorunlu')
    if (form.role === 'brand_admin' && !form.brand_id) return alert('Marka seçimi zorunlu')
    try {
      await axios.post(`${API}/admin/users`, {
        ...form,
        brand_id: form.brand_id ? parseInt(form.brand_id) : null
      }, { headers })
      setForm({ email: '', password: '', role: 'brand_admin', brand_id: '' })
      setShowAdd(false)
      fetchUsers()
      showSaved()
    } catch (e) {
      alert('Kullanıcı eklenemedi')
    }
  }

  async function handleUpdate() {
    try {
      await axios.put(`${API}/admin/users/${editing.id}`, {
        ...editing,
        brand_id: editing.brand_id ? parseInt(editing.brand_id) : null
      }, { headers })
      setEditing(null)
      fetchUsers()
      showSaved()
    } catch (e) {
      alert('Güncellenemedi')
    }
  }

  async function handleSendReset(u) {
    if (!window.confirm(`${u.email} adresine şifre sıfırlama bağlantısı gönderilsin mi?`)) return
    setResetBekleyen(u.id)
    try {
      await axios.post(`${API}/admin/users/${u.id}/password-reset`, {}, { headers })
      setResetGonderilen(u.id)
      setTimeout(() => setResetGonderilen(null), 4000)
    } catch (e) {
      alert(e.response?.data?.error || 'Bağlantı gönderilemedi')
    }
    setResetBekleyen(null)
  }

  async function handleDelete(userId) {
    if (userId === account?.id) return alert('Kendi hesabınızı silemezsiniz')
    if (!window.confirm('Bu kullanıcıyı silmek istediğinize emin misiniz?')) return
    await axios.delete(`${API}/admin/users/${userId}`, { headers })
    fetchUsers()
  }

  const getBrandName = (brandId) => {
    const brand = brands.find(b => b.id === brandId)
    return brand ? brand.name : '-'
  }

  if (loading) return <p style={ui.emptyText}>Yükleniyor...</p>

  return (
    <div>
      <div className="sx-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '12px', marginBottom: '24px' }}>
        <h2 style={s.pageTitle}>Kullanıcı Yönetimi</h2>
        <button onClick={() => setShowAdd(true)} style={s.btnPrimary}>
          + Yeni Kullanıcı
        </button>
      </div>

      {saved && <p style={{ ...ui.notice, display: 'inline-block', marginBottom: '16px' }}>Kaydedildi ✓</p>}

      {showAdd && (
        <div style={{ ...style.card, marginBottom: '24px' }}>
          <h3 style={{ ...s.sectionTitle, margin: '0 0 20px' }}>Yeni Kullanıcı</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
            <div>
              <label style={style.label}>E-posta *</label>
              <input style={style.input} value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="kullanici@email.com" />
            </div>
            <div>
              <label style={style.label}>Şifre *</label>
              <input type="password" style={style.input} value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="Şifre" />
            </div>
            <div>
              <label style={style.label}>Rol</label>
              <select style={s.select} value={form.role} onChange={e => setForm({ ...form, role: e.target.value, brand_id: '' })}>
                <option value="brand_admin">Marka Admin</option>
                <option value="super_admin">Super Admin</option>
              </select>
            </div>
            {form.role === 'brand_admin' && (
              <div>
                <label style={style.label}>Marka *</label>
                <select style={s.select} value={form.brand_id} onChange={e => setForm({ ...form, brand_id: e.target.value })}>
                  <option value="">Marka Seç</option>
                  {brands.map(b => (
                    <option key={b.id} value={b.id}>{b.name}</option>
                  ))}
                </select>
              </div>
            )}
          </div>
          <div className="sx-wrap" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <button onClick={handleAdd} style={s.btnPrimary}>Kaydet</button>
            <button onClick={() => setShowAdd(false)} style={s.btnSecondary}>İptal</button>
          </div>
        </div>
      )}

      <div style={{ ...style.card, padding: 0, overflow: 'hidden' }}>
        <div className="sx-scroll-x">
        <table className="sx-cards" style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>E-posta</th>
              <th style={s.th}>Rol</th>
              <th style={s.th}>Marka</th>
              <th style={s.th}>Oluşturulma</th>
              <th style={s.th}></th>
            </tr>
          </thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id}>
                {editing?.id === u.id ? (
                  <>
                    <td data-label="E-posta" style={s.td}>
                      <input style={{ ...s.inputSm, margin: 0 }} value={editing.email} onChange={e => setEditing({ ...editing, email: e.target.value })} />
                    </td>
                    <td data-label="Rol" style={s.td}>
                      <select style={{ ...s.inputSm, margin: 0 }} value={editing.role} onChange={e => setEditing({ ...editing, role: e.target.value, brand_id: '' })}>
                        <option value="brand_admin">Marka Admin</option>
                        <option value="super_admin">Super Admin</option>
                      </select>
                    </td>
                    <td data-label="Marka" style={s.td}>
                      {editing.role === 'brand_admin' ? (
                        <select style={{ ...s.inputSm, margin: 0 }} value={editing.brand_id || ''} onChange={e => setEditing({ ...editing, brand_id: e.target.value })}>
                          <option value="">Marka Seç</option>
                          {brands.map(b => (
                            <option key={b.id} value={b.id}>{b.name}</option>
                          ))}
                        </select>
                      ) : <span style={{ color: colors.textMuted }}>-</span>}
                    </td>
                    <td data-label="Oluşturulma" style={s.td}>
                      <input type="password" style={{ ...s.inputSm, margin: 0 }} placeholder="Yeni şifre (boş = değişmez)" onChange={e => setEditing({ ...editing, password: e.target.value })} />
                    </td>
                    <td style={s.td}>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button onClick={handleUpdate} style={ui.btnPrimarySm}>Kaydet</button>
                        <button onClick={() => setEditing(null)} style={ui.btnSm}>İptal</button>
                      </div>
                    </td>
                  </>
                ) : (
                  <>
                    <td data-label="E-posta" style={s.td}>
                      {u.email}
                      {u.id === account?.id && <span style={{ color: colors.textMuted, fontSize: '11px', marginLeft: '8px' }}>(siz)</span>}
                    </td>
                    <td data-label="Rol" style={s.td}>
                      <span style={u.role === 'super_admin' ? ui.chipStrong : ui.chip}>
                        {u.role === 'super_admin' ? 'Super Admin' : 'Marka Admin'}
                      </span>
                    </td>
                    <td data-label="Marka" style={{ ...s.td, color: colors.textSecondary }}>{u.brand_id ? getBrandName(u.brand_id) : '-'}</td>
                    <td data-label="Oluşturulma" style={{ ...s.td, color: colors.textSecondary }}>
                      {new Date(u.created_at).toLocaleDateString('tr-TR')}
                    </td>
                    <td style={s.td}>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button onClick={() => setEditing({ ...u })} style={ui.btnSm}>Düzenle</button>
                        <button onClick={() => handleSendReset(u)} disabled={resetBekleyen === u.id}
                          title="Kullanıcıya e-posta ile şifre yenileme bağlantısı gönderir"
                          style={{ ...ui.btnSm,
                            background: resetGonderilen === u.id ? colors.bgPage : colors.bgCard,
                            color: resetGonderilen === u.id ? colors.textSecondary : colors.textPrimary,
                            cursor: resetBekleyen === u.id ? 'default' : 'pointer',
                            opacity: resetBekleyen === u.id ? 0.6 : 1 }}>
                          {resetGonderilen === u.id ? 'Gönderildi ✓' : resetBekleyen === u.id ? 'Gönderiliyor…' : 'Şifre Sıfırla'}
                        </button>
                        {u.id !== account?.id && (
                          <button onClick={() => handleDelete(u.id)} style={ui.btnDangerQuiet}>Sil</button>
                        )}
                      </div>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
    </div>
  )
}

export default Users